import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody, Row, Col } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import {
  FaTachometerAlt,
  FaBoxes,
  FaShoppingCart,
  FaShoppingBasket,
  FaCalculator,
  FaCog,
  FaUserCircle,
  FaSignOutAlt,
  FaSave,
  FaSun,
  FaMoon,
  FaLayerGroup
} from 'react-icons/fa';
import { authActions } from '../../sagas/authSlice';
import './ModuleSelector.css';

const ModuleSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fullName, businessName } = useSelector(state => state.auth);

  const [darkMode, setDarkMode] = useState(false);


  const modules = [
    { id: 'dashboard', title: t('modules.dashboard.title'), icon: FaTachometerAlt, color: '#0d6efd', route: '/dashboard' },
    { id: 'inventory', title: t('modules.inventory.title'), icon: FaBoxes, color: '#198754', route: '/inventory-module' },
    { id: 'pos', title: 'Point de Vente', icon: FaShoppingCart, color: '#d63384', route: '/comptoire' },
    { id: 'sales', title: t('modules.sales.title'), icon: FaShoppingCart, color: '#0dcaf0', route: '/sales-module' },
    { id: 'purchases', title: t('modules.purchases.title'), icon: FaShoppingBasket, color: '#fd7e14', route: '/purchases-module' },
    { id: 'dala', title: t('modules.dala.title'), icon: FaLayerGroup, color: '#fd7e14', route: '/dala-module' },
    // { id: 'accounting', title: t('modules.accounting.title'), icon: FaCalculator, color: '#6610f2', route: '/accounting-module' },
    { id: 'backups', title: t('modules.backups.title'), icon: FaSave, color: '#115c9eff', route: '/backups-module' },
    { id: 'settings', title: t('modules.settings.title'), icon: FaCog, color: '#6c757d', route: '/settings-module' },
  ];

  useEffect(() => {
    const onKey = (e) => {
      const idx = Number(e.key) - 1;
      if (idx >= 0 && idx < modules.length) {
        navigate(modules[idx].route);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  /* ===== Dark mode ===== */
  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Confirmer la déconnexion',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Se déconnecter',
      cancelButtonText: 'Annuler'
    }).then((r) => {
      if (r.isConfirmed) {
        dispatch(authActions.logout());
        localStorage.clear();
        navigate('/login');
      }
    });
  };

  const chunkModules = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const moduleRows = chunkModules(modules, 4);


  return (
    <div className="module-selector-wrapper">

      {/* HERO */}
      <div className="hero-section">
        <Container className="hero-content-centered">
          <h2 className="hero-title">
            {t('modules.welcome', { businessName })}
          </h2>

          <div className="hero-right">
            <button
              className="theme-toggle"
              onClick={() => setDarkMode(v => !v)}
            >
              {darkMode ? <FaSun /> : <FaMoon />}
            </button>

            <div className="user-pill">
              <FaUserCircle />
              <span>{fullName}</span>
            </div>

            <button className="logout-btn" onClick={handleLogout}>
              <FaSignOutAlt />
              <span>Déconnexion</span>
            </button>
          </div>
        </Container>
      </div>

      {/* MODULES */}
      <Container className="modules-container">
        <div className="modules-grid">
          {modules.map((m, i) => (
            <Card
              key={i}
              className={`module-card-dense ${m.primary ? 'primary' : ''}`}
              onClick={() => navigate(m.route)}
            >
              <CardBody className="module-card-body-dense text-center">
                <span className="shortcut">{i + 1}</span>
                <m.icon size={30} />
                <div className="module-title-dense">{m.title}</div>
              </CardBody>
            </Card>
          ))}
        </div>
      </Container>

      {/* FOOTER */}
      <footer className="app-footer">
        <Container className="footer-content">
          <span><strong>{businessName}</strong> — ERP & POS</span>
          <span>© {new Date().getFullYear()}</span>
          <span>Powered by <strong>IDERACLOUD</strong></span>
        </Container>
      </footer>

    </div>
  );

};

export default ModuleSelector;
